import React, { ReactNode } from 'react';
import Avatar from '../Avatar';
import Wrapper from '../Wrapper';
import Text from '../Text';
import Title from '../Title';

import './TeacherProfileCard.less';

export type TeacherTypeProps = {
  image?: string;
  name: string;
  aboutList: [{ lable: ReactNode; content: ReactNode }];
  school?: string;
  subject?: string;
  groups?: ReactNode;
  bio?: string;
  height?: string | number;
  moreInfo?: ReactNode;
  videoCard?: ReactNode;
};

const TeacherProfileCard: React.FC<TeacherTypeProps> = ({
  name,
  image,
  height,
  aboutList = [],
  moreInfo,
  videoCard,
}) => {
  return (
    <>
      <div
        className="e-teacher-profile-container"
        style={{ height: height || 'auto', overflow: 'auto' }}
      >
        <div>
          <div className={'e-image'}>
            <Wrapper mb={1} display="flex" justifyContent="center">
              <Avatar name={name} size="xxxl" src={image} />
            </Wrapper>
            <Wrapper textAlign="center" mb={1}>
              <Title level={4} rows={1}>
                {name}
                {moreInfo && (
                  <Wrapper
                    display="flex"
                    justifyContent="center"
                    textAlign="center"
                  >
                    {moreInfo}
                  </Wrapper>
                )}
              </Title>
            </Wrapper>
          </div>
          <div className={'e-about'}>
            {!!aboutList.length &&
              aboutList.map((item, index) => (
                <Wrapper display="flex" py={3} key={index}>
                  <label className="e-label">{item.lable}:</label>
                  <Text rows={1} level={3}>
                    {item.content}
                  </Text>
                </Wrapper>
              ))}
          </div>
        </div>

        {/* How to ...  video section */}
        {!!videoCard && (
          <div className="e-videoSection">
            <Wrapper display="flex" pt={1} mt={1} flexDirecton="column">
              {videoCard}
            </Wrapper>
          </div>
        )}
      </div>
    </>
  );
};

export default TeacherProfileCard;
